enum SuperType {
  GUARANTEE = 'Guarantee',
  PERSONAL_CONTRIBUTION = 'Personal contribution',
  SALARY_SACRIFICE = 'Salary sacrifice'
}

export default SuperType;
